export const config = {
  product: 'Octopus',
  productType: 'SportClubsLeisureComm',
  webBuildId: 'f6302b6b-da2f-4d6d-9853-3b0ce94b8b84',
  juiceWebApiUrl: window.juiceWebApiUrl ?? 'https://ripethinking.co.uk/juicewebapi',
  paymentUrl: window.paymentUrl ?? 'http://payments.ripeinsurance.co.uk/sclc?tid=',
  paymentUrlParameters: [
    {
      questionId: '382f07f8-edc7-4f3a-8217-de0308cd15bd',
      parameter: 'orgType',
    },
    {
      questionId: '9b930473-b21d-4517-9f24-de0be10d39ec',
      isGroupQuestion: true,
      parameter: 'sportType',
    },
  ],
  reCaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
};
